export const CUSTOMER_POINTS_STATES = [
  { label: 'Cancelado', value: 'canceled' },
  { label: 'Expirado', value: 'expired' },
  { label: 'Gastado', value: 'spent' },
  { label: 'Disponible', value: 'available' },
];



// WEBPACK FOOTER //
// ./src/app/constants/customer-points-states.ts